import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { getDisplayImageObj } from "@vc-workspace/utils-helpers";
import { productImageStyles } from "./product-reviews-header.module.style";
import { Typography } from "@vc-workspace/utils-typography";
import { TailwindColors } from "@vc-workspace/utils-colors";
import { amountFormatter } from "@vc-workspace/utils-formatters";
export function ProductReviewsHeader(props) {
  var displayImage = getDisplayImageObj(props.sia.itemDetail.images[0], "3");
  return _jsxs(_Fragment, {
    children: [_jsxs("picture", {
      children: [_jsx("source", {
        srcSet: displayImage.webP,
        type: "image/webp"
      }), _jsx("img", {
        src: displayImage.url,
        css: productImageStyles
      })]
    }), _jsxs("div", {
      className: "flex items-start justify-between mt-5",
      children: [_jsxs("div", {
        className: "w-3/4",
        children: [_jsx(Typography, {
          type: "Body1",
          color: TailwindColors.grey[600],
          children: props.sia.shopName
        }), _jsx(Typography, {
          type: "Headline_H3",
          color: TailwindColors.grey[900],
          bold: true,
          children: props.sia.itemDetail.name
        })]
      }), _jsxs("div", {
        children: [_jsx(Typography, {
          type: "Body1",
          color: TailwindColors.grey[600],
          children: "Price"
        }), _jsxs(Typography, {
          type: "Headline_H3",
          color: TailwindColors.grey[900],
          bold: true,
          children: ["\u20B9", amountFormatter(props.sia.meta.bestMpPrice.sellingPrice / 100)]
        })]
      })]
    })]
  });
}
export default ProductReviewsHeader;